export default "__VITE_ASSET__95bd62cb__"